import { ToothSvgComponentProps } from '@/modules/patientList/patientStrip/patientStripOdontogram/types';

const SvgNormal = (props: ToothSvgComponentProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12 * (props.wx ?? 1)}
    height={32 * (props.hx ?? 1)}
    viewBox="0 0 12 32"
    fill="none"
    className={props.className}
  >
    <path
      fill={props.fill || '#E4E4E7'}
      stroke={props.stroke || '#A1A1AA'}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10.602 2.96c-.519-.75-1.187-.643-1.965-.969-1.012-.424-1.488-.942-2.32-.989-.884-.05-2.175.738-2.712.842-.851.165-1.542.238-2.178 1.006-1.05 1.268.117 7.435.524 8.57.312.87.482 1.187.787 2.255.335 1.17.744 6.663.709 11.74-.025 3.602.443 6.045 1.166 6.051.625.006 1.054-2.136 1.97-5.388 1.522-5.41 1.454-8.104 2.118-11.795.161-.897.33-2.113.764-2.835.158-.263.327-.674.454-1.037.619-1.772 1.537-6.215.683-7.45z"
    />
  </svg>
);
export default SvgNormal;
